export const GIFT_CARD_20  = 20
export const GIFT_CARD_50  = 50
export const GIFT_CARD_100 = 100

/*
These paths are also hardcoded in `cs-core` and used in various emails sent by
it, and should not be changed.
*/
export const GIFT_CARD_ANY_IMAGE = `/images/gift-cards/any.jpg`
export const GIFT_CARD_20_IMAGE  = `/images/gift-cards/20.jpg`
export const GIFT_CARD_50_IMAGE  = `/images/gift-cards/50.jpg`
export const GIFT_CARD_100_IMAGE = `/images/gift-cards/100.jpg`
export const GIFT_CARDS = [
  {
    amount: `any`,
    image: GIFT_CARD_ANY_IMAGE,
  },
  {
    amount: GIFT_CARD_20,
    image: GIFT_CARD_20_IMAGE,
  },
  {
    amount: GIFT_CARD_50,
    image: GIFT_CARD_50_IMAGE,
  },
  {
    amount: GIFT_CARD_100,
    image: GIFT_CARD_100_IMAGE,
  },
]
